<template>
    <div class="search">
        <div class="header container">
            <div class="item">
                <div class="title">CAS号：</div>
                <div class="item-content" :class="{ fix: !casShowMore, more: casHeight > 200 }">
                    <div class="content" ref="cas">
                        <span
                            v-if="casCodeList.length > 1"
                            :class="{ active: queryCasCode === '' }"
                            @click="queryCasCode = ''"
                            >全部</span
                        >
                        <span
                            v-for="(val, index) in casCodeList"
                            :key="index"
                            :class="{ active: queryCasCode === val.casCode }"
                            @click="queryCasCode = val.casCode"
                            >{{ val.casCode }}</span
                        >
                    </div>

                    <p v-if="casHeight > 200" @click="casShowMore = !casShowMore">
                        {{ casShowMore ? '收起...' : '加载更多...' }}
                    </p>
                </div>
            </div>
            <div class="item">
                <div class="title">品牌：</div>
                <div class="item-content" :class="{ fix: !brandShowMore, more: brandHeight > 200 }">
                    <div class="content" ref="brand">
                        <span
                            v-if="brandList.length > 1"
                            :class="{ active: brandId === '' }"
                            @click="brandId = ''"
                            >全部</span
                        >
                        <span
                            v-for="(val, index) in brandList"
                            :key="index"
                            @click="brandId = val.brandId"
                            :class="{ active: brandId === val.brandId }"
                            >{{ val.brandName }}</span
                        >
                    </div>

                    <p v-if="brandHeight > 200" @click="brandShowMore = !brandShowMore">
                        {{ brandShowMore ? '收起...' : '加载更多...' }}
                    </p>
                </div>
            </div>
        </div>

        <Condtion
            :productList="productList"
            :pageSize="pageSize"
            @handleCurrentChange="handleCurrentChange"
            :isshow="isshow"
            :key="times"
            @changeCloseStatus="changeCloseStatus"
            :userInfo="userInfo"
            @changShopNum="changShopNum"
        ></Condtion>
    </div>
</template>

<script>
import * as apis from '../../fetch/search';
import * as userApis from '../../fetch/user';

import Condtion from './Condtion';

export default {
    components: {
        Condtion,
    },
    data() {
        return {
            times: 0,
            searchContent: '',
            classId: '',

            //实时数据
            casCodeList: [],
            brandList: [], //品牌列表
            packageUnitList: [], //包装单位列表
            qualitySpecsList: [], //纯度列表

            productList: {}, // 查询出来的结果

            //查询条件
            queryCasCode: '',
            brandId: '',
            packingUnit: '',
            qualitySpecs: '',
            pageSize: 20,

            casHeight: 0,
            casShowMore: false,

            brandHeight: 0,
            brandShowMore: false,
            isshow: false,

            userInfo: null,
        };
    },
    name: 'Search',
    mounted() {
        this.searchContent = this.$route.query.q;
        this.classId = this.$route.params.id;
        this.getHeader();
        this.getUserInfo();
    },
    watch: {
        queryCasCode() {
            this.getList(1);
        },
        brandId() {
            this.getList(1);
        },
        packingUnit() {
            this.getList(1);
        },
        qualitySpecs() {
            this.getList(1);
        },
        $route() {
            this.searchContent = this.$route.query.q;
            this.classId = this.$route.params.id;
            this.getHeader();
        },
        casCodeList() {
            this.$nextTick(() => {
                this.casHeight = this.$refs.cas.offsetHeight;
                this.casShowMore = this.$refs.cas.offsetHeight <= 200;
            });
        },
        brandList() {
            this.$nextTick(() => {
                console.log(this.$refs.brand.offsetHeight);
                this.brandHeight = this.$refs.brand.offsetHeight;
                this.brandShowMore = this.$refs.brand.offsetHeight <= 200;
            });
        },
    },
    methods: {
        changeCloseStatus(num) {
            this.productList.list[num].closestatus = this.productList.list[num].closestatus
                ? false
                : true;
            this.times = new Date().getTime();
        },
        changShopNum(num) {
            this.productList.list[num].shopNum += 1;
            this.times = new Date().getTime();
        },
        getUserInfo() {
            userApis.getUserInfo().then(res => {
                this.userInfo = res;
            });
        },
        getHeader() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });

            apis.getSearchHeader({ searchContent: this.searchContent, classId: this.classId })
                .then(res => {
                    this.casCodeList = res.casCodeList;
                    this.brandList = res.brandList;
                    this.queryCasCode =
                        res.casCodeList.length === 1 ? res.casCodeList[0].casCode : '';
                    // debugger;
                    this.brandId = res.brandList.length === 1 ? res.brandList[0].brandId : '';
                    // if (res.casCodeList.length > 1 && res.brandList.length > 1) {
                    this.getList();
                    // }

                    loading.close();
                })
                .catch(() => {
                    loading.close();
                });
        },
        getList(page = 1) {
            const params = {
                searchContent: this.searchContent,
                classId: this.classId,
                page: page,
                pageSize: this.pageSize,
                brandId: this.brandId,
                queryCasCode: this.queryCasCode,
            };

            apis.getSearchList(params).then(res => {
                const list = res.list.map(r => ({ ...r, shopNum: 1 }));
                this.productList = { ...res, list };
                let brandName = this.productList.list[0].brandName;
                if (brandName === '先丰纳米') {
                    this.isshow = true;
                    this.productList.list.forEach(item => {
                        apis.getDetailList({
                            productId: item.productId,
                            page: 1,
                            pageSize: 10,
                        }).then(res => {
                            let detailList = res.map(r => ({ ...r, shopNum: 1 }));
                            item.detailList = detailList;
                            item.closestatus = false;
                            this.times = new Date().getTime();
                        });
                    });
                    console.log(this.productList.list);
                } else {
                    this.isshow = false;
                }
            });
        },
        handleCurrentChange(page) {
            this.getList(page);
        },
    },
};
</script>

<style lang="less" scoped>
.search {
    .header {
        background-color: #fff;
        padding: 10px 0;
        font-size: 13px;
        margin-bottom: 15px;
        .item {
            display: flex;
            justify-content: flex-start;
            line-height: 32px;
            margin-top: 10px;
            .title {
                width: 100px;
                color: #9e9e9e;
                text-align: center;
                font-size: 14px;
            }
            .item-content {
                flex: 1;
            }
            .content {
                display: flex;
                flex-wrap: wrap;
                color: #666;
                span {
                    padding: 0 20px;
                    color: #2b2b2b;
                    cursor: pointer;
                }
                .active {
                    background-color: #3c9539;
                    border-radius: 20px;
                    color: #fff;
                }
            }
            .item-content.fix {
                height: 200px;
                overflow: hidden;
            }
            .item-content.more {
                padding-bottom: 30px;
                position: relative;
                p {
                    width: 100%;
                    margin: 0;
                    line-height: 30px;
                    text-align: center;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    cursor: pointer;
                    background-color: #fff;
                    color: #999;
                }
            }
        }
    }

    .product-info {
        padding: 20px 0;
        background-color: #fff;
        font-size: 14px;
        margin-top: 10px;
        .title {
            color: #9e9e9e;
            margin-right: 32px;
        }
    }
}
</style>
